import { Component, Inject, Input, AfterViewInit, ViewChild } from "@angular/core";

import { OnInit } from "@angular/core";
import { MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: "rm-provenance-map",
  templateUrl: "./provenance-map.component.html",
  styleUrls: ["./provenance-map.component.css"]
})
export class ProvenanceMapComponent implements OnInit {

    google: any;
    gmap: any;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {}

    ngOnInit() {
        this.google = window['google'];
        this.gmap = new this.google.maps.Map(document.getElementById('rm_provenancemap_div'), {
            center: this.data.center,
            zoom: this.data.zoom || 8,
            mapId: '32c64ca2d80e5193'
        });

        var locations = this.data.locations || [];

        var thisref = this;
        var curveMarkers = [];
        var curveMarkerParams = [];

        var ln = locations.length;
        for (var i = 0; i < ln; i++) {
            var l = locations[i];
            var loc = {lat: parseFloat(l.position[0]), lng: parseFloat(l.position[1])};

            if (i == 0) {
                var marker = new this.google.maps.Marker({
                    position: loc,
                    map: this.gmap,
                    animation: this.google.maps.Animation.DROP,
                    icon: {
                        url: '../assets/images/factory2.png',
                        scaledSize: new this.google.maps.Size(50, 50),
                        origin: new this.google.maps.Point(0, 0),
                        anchor: new this.google.maps.Point(25, 25),
                    },
                    zIndex: 100
                });
            
                var ringMarker = new this.google.maps.Marker({
                    position: loc,
                    icon: {
                        path: this.google.maps.SymbolPath.CIRCLE,
                        scale: 27,
                        strokeWeight: 6,
                        strokeColor: '#1B61CC',
                    },
                    map: this.gmap,
                    zIndex: 10
                });
                
                ringMarker.bindTo("position", marker);
            } else {
                var marker = new this.google.maps.Marker({
                    position: loc,
                    icon: {
                        path: this.google.maps.SymbolPath.CIRCLE,
                        scale: 12,
                        strokeWeight: 6,
                        strokeColor: '#1B61CC',
                    },
                    map: this.gmap,
                    zIndex: 10
                });
            }

            (new this.google.maps.InfoWindow({
                content: l.label,
                position: {lat: parseFloat(l.position[0]), lng: parseFloat(l.position[1])}
            })).open(this.gmap, marker);

            if (!(i+1 == ln)) {
                var nextLocation = locations[i+1];
                var pos1 = {lat: parseFloat(l.position[0]), lng: parseFloat(l.position[1])};
                var pos2 = {lat: parseFloat(nextLocation.position[0]), lng: parseFloat(nextLocation.position[1])};

                curveMarkerParams.push([thisref, pos1, pos2,]);
            }
        }

        thisref.google.maps.event.addListener(this.gmap, 'projection_changed', function() {
            for (var i = 0; i < curveMarkers.length; i++) {
                curveMarkers[i].setMap(null);
            }
            curveMarkers = [];

            curveMarkerParams.forEach(element => {
                updateCurveMarker(element[0], element[1], element[2]);
            })
        });
        this.google.maps.event.addListener(this.gmap, 'zoom_changed', function() {
            for (var i = 0; i < curveMarkers.length; i++) {
                curveMarkers[i].setMap(null);
            }
            curveMarkers = [];

            curveMarkerParams.forEach(element => {
                updateCurveMarker(element[0], element[1], element[2]);
            })
        });

        function updateCurveMarker(thisref, pos1, pos2) {
            var position1 = new thisref.google.maps.LatLng(pos1);
            var position2 = new thisref.google.maps.LatLng(pos2); 
    
            var projection = thisref.gmap.getProjection();
            var p1 = projection.fromLatLngToPoint(position1); // xy
            var p2 = projection.fromLatLngToPoint(position2);
    
            var curvature = 0.5; // how curvy to make the arc

            // Calculate the arc.
            // To simplify the math, these points 
            // are all relative to p1:
            var e = new thisref.google.maps.Point(p2.x - p1.x, p2.y - p1.y), // endpoint (p2 relative to p1)
                m = new thisref.google.maps.Point(e.x / 2, e.y / 2), // midpoint
                o = new thisref.google.maps.Point(e.y, -e.x), // orthogonal
                c = new thisref.google.maps.Point( // curve control point
                    m.x + curvature * o.x,
                    m.y + curvature * o.y);
    
            var pathDef = 'M 0,0 ' +
                'q ' + c.x + ',' + c.y + ' ' + e.x + ',' + e.y;
    
            var zoom = thisref.gmap.getZoom(),
                scale = 1 / (Math.pow(2, -zoom));
    
            var symbol = {
                path: pathDef,
                scale: scale,
                strokeWeight: 2,
                fillColor: 'red',
                // geodesic: true,
            };
    
            var curveMarker = new thisref.google.maps.Marker({
                position: pos1,
                clickable: false,
                icon: symbol,
                zIndex: 0, // behind the other markers
                map: thisref.gmap
            });

            curveMarkers.push(curveMarker);

        }
    }

}